import React from "react";

const About = () => {
  return (
    <>
      <div className='container w-50'>
        <h3 className='m-5 p-3 fw-bold text-center'>About Us</h3>
        <p className='p-5 pt-0 lead'>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae
          repudiandae architecto qui adipisci in officiis, aperiam sequi atque
          perferendis eos, autem maiores nisi saepe quisquam hic odio
          consectetur nobis veritatis quasi explicabo obcaecati doloremque?
          Placeat ratione hic aspernatur error blanditiis?
        </p>
      </div>
    </>
  );
};

export default About;
